import { render, staticRenderFns } from "./WorkEventDialog.vue?vue&type=template&id=4f0f3bbe&scoped=true"
import script from "./WorkEventDialog.vue?vue&type=script&lang=js"
export * from "./WorkEventDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkEventDialog.vue?vue&type=style&index=0&id=4f0f3bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f3bbe",
  null
  
)

export default component.exports